import { graphql } from "@/graphql"

export const PostAttachmentFragment = graphql(`
  fragment PostAttachmentFragment on Post {
    id
    publishedAt
    currentVersion {
      id
      title
    }
  }
`)

export const DraftPostsFragment = graphql(`
  fragment DraftPostFragment on Post {
    id
    currentVersion {
      id
      title
    }
  }
`)
